import React from "react";
import { useState, useEffect } from "react";
import "./order-details.css";
import ProgressTrackertwo from "../Progresstracker/ProgressTrackertwo";
import OrderSummary from "./OrderSummary";
import { Link } from "react-router-dom";
import StarRating from "../Productdetails/StarRating";
function Orderdetails() {
  
  const [rating, setRating] = useState(0); // State for rating

  return (
    <section className="order_details_section pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-10">
            <div className="inner_box_one">
              <h5>
                Your Order will be Delivered on <b>12th Oct 2024</b>
              </h5>
              <Link
                to="/select-return-products"
                style={{ textDecoration: "none" }}
                className="btn_1_1"
              >
                Return Product
              </Link>
            </div>
            <div className="progressbartracking_two">
              <ProgressTrackertwo currentstep={4} />
            </div>
            <div className="order_summary">
              <OrderSummary />
            </div>
            <div className="order_details_prouduct_list_main_box">
              <div className="order_details_prouduct_list table-responsive">
                <table
                  className="table w-100"
                  style={{ borderBottom: "1px solid transparent" }}
                >
                  <tbody>
                    <tr>
                      <td style={{ width: "12%", verticalAlign: "middle" }}>
                        <div
                          className="img_box"
                          style={{ width: "60%", margin: "auto" }}
                        >
                          {/* <img src={Image1} alt="" /> */}
                        </div>
                      </td>
                      <td
                        className="item_name"
                        style={{ width: "45%", verticalAlign: "middle" }}
                      >
                        <div>
                          <p className="mb-0">
                            Groundnut Oil, 1ltr / கடலை எண்ணெய் 
                          </p>
                          <div className="price_qty_box">
                            {" "}
                            <span>2 Qty</span>
                            <span>₹ 1200</span>
                          </div>
                        </div>
                      </td>
                      <td style={{ width: "22%", verticalAlign: "middle" }}>
                        <div className="rate_this_product_main_box">
                          <div className="rate_product_inner_box">
                            <p
                              className="text-center mb-0"
                              style={{ color: "#76a70e" }}
                            >
                              Rate this Product
                            </p>
                            <StarRating
                              rating={rating}
                              onRatingChange={setRating}
                            />
                          </div>
                        </div>
                      </td>
                      <td
                        style={{ width: "21%", verticalAlign: "middle" }}
                        className="text-center"
                      >
                        <button className="btn_1_1">Buy Again</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="order_details_prouduct_list table-responsive">
                <table
                  className="table w-100"
                  style={{ borderBottom: "1px solid transparent" }}
                >
                  <tbody>
                    <tr>
                      <td style={{ width: "12%", verticalAlign: "middle" }}>
                        <div
                          className="img_box"
                          style={{ width: "60%", margin: "auto" }}
                        >
                          {/* <img src={Image1} alt="" /> */}
                        </div>
                      </td>
                      <td
                        className="item_name"
                        style={{ width: "45%", verticalAlign: "middle" }}
                      >
                        <div>
                          <p className="mb-0">
                            Groundnut Oil, 1ltr / கடலை எண்ணெய் 
                          </p>
                          <div className="price_qty_box">
                            {" "}
                            <span>2 Qty</span>
                            <span>₹ 1200</span>
                          </div>
                        </div>
                      </td>
                      <td style={{ width: "22%", verticalAlign: "middle" }}>
                        <div className="rate_this_product_main_box">
                          <div className="rate_product_inner_box">
                            <p
                              className="text-center mb-0"
                              style={{ color: "#76a70e" }}
                            >
                              Rate this Product
                            </p>
                            <StarRating
                              rating={rating}
                              onRatingChange={setRating}
                            />
                          </div>
                        </div>
                      </td>
                      <td
                        style={{ width: "21%", verticalAlign: "middle" }}
                        className="text-center"
                      >
                        <button className="btn_1_1">Buy Again</button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Orderdetails;
